import { LazyQueryHookOptions, useLazyQuery } from '@apollo/client'
import checkoutSessionRuleQuery from './query'
import {
  ICheckoutSessionRuleResponse,
  ICheckoutSessionRuleVariables,
} from './types'

const useLazyCheckoutSessionRule = (
  options?: Omit<
    LazyQueryHookOptions<
      ICheckoutSessionRuleResponse,
      ICheckoutSessionRuleVariables
    >,
    'fetchPolicy' | 'nextFetchPolicy' | 'initialFetchPolicy'
  >,
) => {
  return useLazyQuery<
    ICheckoutSessionRuleResponse,
    ICheckoutSessionRuleVariables
  >(checkoutSessionRuleQuery, {
    ...options,
    fetchPolicy: 'no-cache',
    // Neutralised beside the pin, not merely omitted from the type: both
    // survive the spread otherwise, and `nextFetchPolicy` would take over
    // from the second fetch onward.
    nextFetchPolicy: undefined,
    initialFetchPolicy: undefined,
  })
}

export { useLazyCheckoutSessionRule }
